import React, { useState, useEffect } from 'react';
import ApiService from '../services/api';
import {
    MonitorCog , SquareActivity , Tickets ,Receipt , Briefcase,
    Menu,
    X,
    Home,
    Package,
    FileText,
    Calendar,
    Users,
    BarChart3,
    Settings,
    Bell,
    Search,
    ChevronDown,
    ArrowRight,
    TrendingUp,
    TrendingDown,
    Building,
    Hammer,
    Truck,
    Star,
    AlertCircle,
    CheckCircle,
    Clock,
    DollarSign,
    Activity,
    Globe,
    Zap,
    Target,
    Award,
    Shield,
    LogOut,
    ChevronRight,
    Filter,
    Download,
    RefreshCw,
    MoreVertical,
    Plus,
    User,
    Edit,
    Trash2,
    Eye,
    Package2,
    Layers,
    Wrench,
    ShoppingCart,
    Box,
    Hash,
    Cable,
    UserCog,
    Calculator,
    Construction,
    Beaker,
    Leaf,
    ShieldCheck,
    Folder
} from 'lucide-react';
import '../Styles/products.css';
import { useNavigate } from 'react-router-dom';
import MepIcon from '../assets/MEP_Solutions.png';
import architecturalIcon from '../assets/architectural_icon.png';
import civilIcon from '../assets/civil-icon.png';
import constructionIcon from '../assets/construction-icon.png';
import powerToolsIcon from '../assets/power-tools_icon.png';
import sustainableIcon from '../assets/sustainable-icon.png';
import hygienicIcon from '../assets/hygienic-icon.png';
import '../Styles/dashboard.css';

const UnitechProductsPage = () => {
    const [user, setUser] = useState(null);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [activeMenuItem, setActiveMenuItem] = useState('inventory');
    const [currentTime, setCurrentTime] = useState(new Date());
    const [notifications, setNotifications] = useState(3);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [searchTerm, setSearchTerm] = useState('');
    const [sortBy, setSortBy] = useState('name');
    const [sortOrder, setSortOrder] = useState('asc');
    const [showEditModal, setShowEditModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const navigate = useNavigate();

    
    const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [pagination, setPagination] = useState({
        page: 1,
        pages: 1,
        total: 0
    });
    const [error, setError] = useState(null);

    const [showAddModal, setShowAddModal] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        category: 'concrete',
        sku: '',
        price: '',
        stock: '',
        minStock: '',
        unit: 'pièce',
        supplier: '',
        description: ''
    });
    const [formError, setFormError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        loadCurrentUser();
    }, []);

    useEffect(() => {
        if (user) {
            loadCategories();
            loadProducts();
        }
    }, [user]);

    useEffect(() => {
        if (user) {
            const timeoutId = setTimeout(() => {
                loadProducts();
            }, 300); 

            return () => clearTimeout(timeoutId);
        }
    }, [selectedCategory, searchTerm, sortBy, sortOrder, user]);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    const loadCurrentUser = async () => {
        try {
            const syncUser = ApiService.getUserSync();
            if (syncUser) {
                setUser(syncUser);
                return;
            }

            const response = await ApiService.getCurrentUser();
            if (response.success) {
                setUser(response.user);
            } else {
                window.location.href = '/login';
            }
        } catch (error) {
            console.error('Failed to load user:', error);
            if (error.message.includes('Authentication required') || error.message.includes('Unauthorized')) {
                window.location.href = '/login';
            }
        }
    };

    const loadCategories = async () => {
        try {
            const response = await ApiService.getCategories();
            if (response.success) {
                setCategories(response.categories);
            }
        } catch (error) {
            console.error('Failed to load categories:', error);
            setError('Failed to load categories');
            setCategories([
                { id: 'all', name: 'Tous les produits', count: 0 },
                { id: 'concrete', name: 'Béton & Ciment', count: 0 },
                { id: 'steel', name: 'Acier & Métaux', count: 0 },
                { id: 'tools', name: 'Outils & Équipements', count: 0 },
                { id: 'electrical', name: 'Électricité', count: 0 },
                { id: 'plumbing', name: 'Plomberie', count: 0 },
                { id: 'safety', name: 'Sécurité', count: 0 }
            ]);
        }
    };

    const loadProducts = async () => {
        try {
            setIsLoading(true);
            setError(null);
            
            const params = {
                category: selectedCategory !== 'all' ? selectedCategory : undefined,
                search: searchTerm || undefined,
                sortBy,
                sortOrder,
                page: pagination.page
            };

            Object.keys(params).forEach(key => {
                if (params[key] === undefined) {
                    delete params[key];
                }
            });

            const response = await ApiService.getProducts(params);
            if (response.success) {
                setProducts(response.products);
                setPagination({
                    page: response.page,
                    pages: response.pages,
                    total: response.total
                });
            }
        } catch (error) {
            console.error('Failed to load products:', error);
            setError('Failed to load products: ' + error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleRefresh = () => {
        loadProducts();
        loadCategories();
    };

    const openAddModal = () => {
        setShowAddModal(true);
        setFormError('');
        setFormData({
            name: '',
            category: 'concrete',
            sku: '',
            price: '',
            stock: '',
            minStock: '10',
            unit: 'pièce',
            supplier: '',
            description: ''
        });
    };

    const closeAddModal = () => {
        setShowAddModal(false);
        setFormError('');
        setFormData({
            name: '',
            category: 'concrete',
            sku: '',
            price: '',
            stock: '',
            minStock: '10',
            unit: 'pièce',
            supplier: '',
            description: ''
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleAddProduct = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setFormError('');

        try {
            if (!formData.name || !formData.sku || !formData.price || !formData.supplier) {
                throw new Error('Veuillez remplir tous les champs obligatoires (nom, SKU, prix, fournisseur)');
            }

            const productData = {
                ...formData,
                price: parseFloat(formData.price),
                stock: parseInt(formData.stock) || 0,
                minStock: parseInt(formData.minStock) || 10
            };

            console.log('Creating product with data:', productData);

            const response = await ApiService.createProduct(productData);
            
            if (response.success) {
                alert('Produit créé avec succès !');
                closeAddModal();
                loadProducts();
                loadCategories();
            }
        } catch (error) {
            console.error('Error creating product:', error);
            setFormError(error.message || 'Erreur lors de la création du produit');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleDeleteProduct = async (productId) => {
        if (window.confirm('Êtes-vous sûr de vouloir supprimer ce produit ?')) {
            try {
                setIsLoading(true);
                const response = await ApiService.deleteProduct(productId);
                if (response.success) {
                    loadProducts();
                    loadCategories();
                    alert('Produit supprimé avec succès');
                }
            } catch (error) {
                console.error('Failed to delete product:', error);
                alert('Erreur lors de la suppression du produit: ' + error.message);
            } finally {
                setIsLoading(false);
            }
        }
    };

    const handleLogout = async () => {
        if (window.confirm('Are you sure you wanna disconnect?')) {
            // Nettoyer les données utilisateur
            ApiService.clearUserData();
            
            // Utiliser React Router pour naviguer vers login
            navigate('/login');
        }
    };



const menuItems = [
    { 
        id: 'barcoding', 
        label: 'Barcoding Database', 
        icon: FileText, // Keep as Lucide icon
        path: '/barcoding' 
    },
    { 
        id: 'mep-solutions', 
        label: 'MEP Solutions', 
        icon: MepIcon, // 🔄 Replace with image
        isImage: true,
        path: '/mep_solutions' 
    },
    { 
        id: 'architectural-solutions', 
        label: 'Architectural Solutions', 
        icon: architecturalIcon , // 🔄 Replace with image
        isImage: true,
        path: '/architectural_solutions' 
    },
    { 
        id: 'civil-solutions', 
        label: 'Civil Solutions', 
        icon: civilIcon, // 🔄 Replace with image
        isImage: true,
        path: '/civil_solutions' 
    },
    { 
        id: 'construction-chemicals', 
        label: 'Construction Chemicals', 
        icon: constructionIcon, // 🔄 Replace with image
        isImage: true,
        path: '/construction_chemicals' 
    },
    { 
        id: 'power-tools', 
        label: 'Power & Industrial Tools', 
        icon: powerToolsIcon, // 🔄 Replace with image
        isImage: true,
        path: '/power_tools' 
    },
    { 
        id: 'sustainable-solutions', 
        label: 'Sustainable Solutions', 
        icon: sustainableIcon, // 🔄 Replace with image
        isImage: true,
        path: '/sustainable_solutions' 
    },
    { 
        id: 'hygienic-solutions', 
        label: 'Hygienic Solutions', 
        icon: hygienicIcon, // 🔄 Replace with image
        isImage: true,
        path: '/hygienic_solutions' 
    },
    { 
        id: 'conversions', 
        label: 'Engineering Conversions', 
        icon: Calculator, // Keep as Lucide icon
        path: '/conversion' 
    },
    { 
        id: 'analytics', 
        label: 'Amazon Products', 
        icon: BarChart3, // Keep as Lucide icon
        path: '/amazon_products' 
    },
    { 
        id: 'team', 
        label: 'Team Management', 
        icon: Users, // Keep as Lucide icon
        path: '/team_management' 
    },
    { 
        id: 'user-management', 
        label: 'User Management', 
        icon: UserCog, // Keep as Lucide icon
        path: '/users_management' 
    },
];

    const filteredMenuItems = menuItems.filter(item => {
        if (item.id === 'team' && user?.role === 'user') return false;
        if (item.id === 'settings' && user?.role !== 'admin') return false;
        return true;
    });

    const getUserInitials = () => {
        if (!user) return 'U';
        const firstInitial = user.firstName ? user.firstName.charAt(0).toUpperCase() : '';
        const lastInitial = user.lastName ? user.lastName.charAt(0).toUpperCase() : '';
        return firstInitial + lastInitial || user.email.charAt(0).toUpperCase();
    };

    const getDisplayName = () => {
        if (!user) return 'Utilisateur';
        if (user.firstName && user.lastName) {
            return `${user.firstName} ${user.lastName}`;
        }
        return user.email;
    };

    const getStatusBadge = (status, stock, minStock) => {
        if (status === 'low_stock' || stock <= minStock) {
            return { text: 'Stock Faible', class: 'status-low-stock' };
        } else if (status === 'out_of_stock' || stock === 0) {
            return { text: 'Rupture', class: 'status-out-of-stock' };
        } else {
            return { text: 'Disponible', class: 'status-available' };
        }
    };

    const getCategoryIcon = (categoryId) => {
        const iconMap = {
            'all': Package2,
            'concrete': Box,
            'steel': Layers,
            'tools': Wrench,
            'electrical': Zap,
            'plumbing': Activity,
            'safety': Shield
        };
        return iconMap[categoryId] || Package2;
    };

    const categoryOptions = [
        { value: 'concrete', label: 'Béton & Ciment' },
        { value: 'steel', label: 'Acier & Métaux' },
        { value: 'tools', label: 'Outils & Équipements' },
        { value: 'electrical', label: 'Électricité' },
        { value: 'plumbing', label: 'Plomberie' },
        { value: 'safety', label: 'Sécurité' }
    ];

    const unitOptions = ['pièce', 'm³', 'ml', 'kg', 'sac', 'boîte', 'rouleau', 'paquet', 'lot'];

if (!user) {
    if (isLoading) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                flexDirection: 'column'
            }}>
                <RefreshCw style={{ width: '24px', height: '24px', animation: 'spin 1s linear infinite' }} />
                <p style={{ marginTop: '16px' }}>Chargement...</p>
            </div>
        );
    }
    return null;
}
const openViewModal = (product) => {
    setSelectedProduct(product);
    setShowViewModal(true);
};

const closeViewModal = () => {
    setShowViewModal(false);
    setSelectedProduct(null);
};

const openEditModal = (product) => {
    setSelectedProduct(product);
    setFormData({
        name: product.name,
        category: product.category,
        sku: product.sku,
        price: product.price.toString(),
        stock: product.stock.toString(),
        minStock: product.minStock.toString(),
        unit: product.unit,
        supplier: product.supplier,
        description: product.description || ''
    });
    setFormError('');
    setShowEditModal(true);
};

const closeEditModal = () => {
    setShowEditModal(false);
    setSelectedProduct(null);
    setFormError('');
};

const handleEditProduct = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setFormError('');

    try {
        if (!formData.name || !formData.sku || !formData.price || !formData.supplier) {
            throw new Error('Veuillez remplir tous les champs obligatoires');
        }

        const productData = {
            ...formData,
            price: parseFloat(formData.price),
            stock: parseInt(formData.stock) || 0,
            minStock: parseInt(formData.minStock) || 10
        };

        const response = await ApiService.updateProduct(selectedProduct._id, productData);
        
        if (response.success) {
            alert('Produit mis à jour avec succès !');
            closeEditModal();
            loadProducts();
            loadCategories();
        }
    } catch (error) {
        setFormError(error.message || 'Erreur lors de la mise à jour');
    } finally {
        setIsSubmitting(false);
    }
};

    return (
        <div className="dashboard-container">
            {showAddModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '24px',
                        width: '90%',
                        maxWidth: '600px',
                        maxHeight: '90vh',
                        overflow: 'auto',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)'
                    }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '24px',
                            paddingBottom: '16px',
                            borderBottom: '2px solid #e5e7eb'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{
                                    width: '40px',
                                    height: '40px',
                                    backgroundColor: '#1e40af',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    <Plus style={{ width: '20px', height: '20px', color: 'white' }} />
                                </div>
                                <div>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#111827' }}>
                                        Ajouter un Produit
                                    </h2>
                                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                                        Créez un nouveau produit dans votre inventaire
                                    </p>
                                </div>
                            </div>
                            <button
                                onClick={closeAddModal}
                                style={{
                                    padding: '8px',
                                    border: 'none',
                                    background: 'none',
                                    cursor: 'pointer',
                                    borderRadius: '6px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <X style={{ width: '20px', height: '20px', color: '#6b7280' }} />
                            </button>
                        </div>
                        {formError && (
                            <div style={{
                                backgroundColor: '#fef2f2',
                                border: '1px solid #fecaca',
                                color: '#dc2626',
                                padding: '12px',
                                borderRadius: '8px',
                                marginBottom: '20px',
                                fontSize: '14px',
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                                {formError}
                            </div>
                        )}
                        <form onSubmit={handleAddProduct}>
                            <div style={{ display: 'grid', gap: '20px' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Package style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Nom du produit *
                                        </label>
                                        <input
                                            type="text"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleInputChange}
                                            placeholder="Ex: Béton C25/30"
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Layers style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Catégorie
                                        </label>
                                        <select
                                            name="category"
                                            value={formData.category}
                                            onChange={handleInputChange}
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            {categoryOptions.map(cat => (
                                                <option key={cat.value} value={cat.value}>
                                                    {cat.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {/* Row 2: SKU and Price */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Hash style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            SKU *
                                        </label>
                                        <input
                                            type="text"
                                            name="sku"
                                            value={formData.sku}
                                            onChange={handleInputChange}
                                            placeholder="Ex: BET-C25-001"
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <DollarSign style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Prix (€) *
                                        </label>
                                        <input
                                            type="number"
                                            step="0.01"
                                            name="price"
                                            value={formData.price}
                                            onChange={handleInputChange}
                                            placeholder="85.50"
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Row 3: Stock, Min Stock, Unit */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            Stock initial
                                        </label>
                                        <input
                                            type="number"
                                            name="stock"
                                            value={formData.stock}
                                            onChange={handleInputChange}
                                            placeholder="0"
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            Stock minimum
                                        </label>
                                        <input
                                            type="number"
                                            name="minStock"
                                            value={formData.minStock}
                                            onChange={handleInputChange}
                                            placeholder="10"
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            Unité
                                        </label>
                                        <select
                                            name="unit"
                                            value={formData.unit}
                                            onChange={handleInputChange}
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            {unitOptions.map(unit => (
                                                <option key={unit} value={unit}>
                                                    {unit}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {/* Row 4: Supplier */}
                                <div>
                                    <label style={{
                                        display: 'block',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        color: '#374151',
                                        marginBottom: '6px'
                                    }}>
                                        <User style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                        Fournisseur *
                                    </label>
                                    <input
                                        type="text"
                                        name="supplier"
                                        value={formData.supplier}
                                        onChange={handleInputChange}
                                        placeholder="Ex: Béton Express SARL"
                                        required
                                        style={{
                                            width: '100%',
                                            padding: '12px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            boxSizing: 'border-box'
                                        }}
                                    />
                                </div>

                                {/* Row 5: Description */}
                                <div>
                                    <label style={{
                                        display: 'block',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        color: '#374151',
                                        marginBottom: '6px'
                                    }}>
                                        Description
                                    </label>
                                    <textarea
                                        name="description"
                                        value={formData.description}
                                        onChange={handleInputChange}
                                        placeholder="Description du produit..."
                                        rows="3"
                                        style={{
                                            width: '100%',
                                            padding: '12px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            boxSizing: 'border-box',
                                            resize: 'vertical'
                                        }}
                                    />
                                </div>
                            </div>

                            {/* Form Actions */}
                            <div style={{
                                display: 'flex',
                                gap: '12px',
                                marginTop: '24px',
                                paddingTop: '20px',
                                borderTop: '1px solid #e5e7eb'
                            }}>
                                <button
                                    type="button"
                                    onClick={closeAddModal}
                                    style={{
                                        flex: 1,
                                        padding: '12px 20px',
                                        border: '1px solid #d1d5db',
                                        background: 'white',
                                        color: '#374151',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Annuler
                                </button>
                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    style={{
                                        flex: 2,
                                        padding: '12px 20px',
                                        border: 'none',
                                        background: isSubmitting ? '#9ca3af' : '#1e40af',
                                        color: 'white',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        cursor: isSubmitting ? 'not-allowed' : 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px'
                                    }}
                                >
                                    {isSubmitting ? (
                                        <>
                                            <RefreshCw style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
                                            Création...
                                        </>
                                    ) : (
                                        <>
                                            <Plus style={{ width: '16px', height: '16px' }} />
                                            Créer le produit
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* VIEW PRODUCT MODAL */}
{showViewModal && selectedProduct && (
    <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex',
        alignItems: 'center', justifyContent: 'center', zIndex: 1000
    }}>
        <div style={{
            backgroundColor: 'white', borderRadius: '12px', padding: '24px',
            width: '90%', maxWidth: '500px', maxHeight: '90vh', overflow: 'auto'
        }}>
            {/* Header */}
            <div style={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid #e5e7eb'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{
                        width: '40px', height: '40px', backgroundColor: '#059669',
                        borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }}>
                        <Eye style={{ width: '20px', height: '20px', color: 'white' }} />
                    </div>
                    <div>
                        <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>
                            Détails du Produit
                        </h2>
                        <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                            {selectedProduct.name}
                        </p>
                    </div>
                </div>
                <button onClick={closeViewModal} style={{ padding: '8px', border: 'none', background: 'none', cursor: 'pointer' }}>
                    <X style={{ width: '20px', height: '20px' }} />
                </button>
            </div>

            {/* Details */}
            <div style={{ display: 'grid', gap: '16px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                    <div>
                        <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>NOM</label>
                        <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>{selectedProduct.name}</p>
                    </div>
                    <div>
                        <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>SKU</label>
                        <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>{selectedProduct.sku}</p>
                    </div>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                    <div>
                        <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>PRIX</label>
                        <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>€{selectedProduct.price.toFixed(2)}</p>
                    </div>
                    <div>
                        <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>STOCK</label>
                        <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>{selectedProduct.stock} {selectedProduct.unit}</p>
                    </div>
                </div>

                <div>
                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>FOURNISSEUR</label>
                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>{selectedProduct.supplier}</p>
                </div>

                {selectedProduct.description && (
                    <div>
                        <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>DESCRIPTION</label>
                        <p style={{ margin: 0, fontSize: '14px' }}>{selectedProduct.description}</p>
                    </div>
                )}
            </div>

            <button onClick={closeViewModal} style={{
                width: '100%', padding: '12px', marginTop: '20px',
                border: '1px solid #d1d5db', background: 'white',
                borderRadius: '8px', cursor: 'pointer'
            }}>
                Fermer
            </button>
        </div>
    </div>
)}

{/* EDIT PRODUCT MODAL */}
{showEditModal && selectedProduct && (
    <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex',
        alignItems: 'center', justifyContent: 'center', zIndex: 1000
    }}>
        <div style={{
            backgroundColor: 'white', borderRadius: '12px', padding: '24px',
            width: '90%', maxWidth: '600px', maxHeight: '90vh', overflow: 'auto',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)'
        }}>
            {/* Header */}
            <div style={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid #e5e7eb'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{
                        width: '40px', height: '40px', backgroundColor: '#f59e0b',
                        borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }}>
                        <Edit style={{ width: '20px', height: '20px', color: 'white' }} />
                    </div>
                    <div>
                        <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#111827' }}>
                            Modifier le Produit
                        </h2>
                        <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                            {selectedProduct.name}
                        </p>
                    </div>
                </div>
                <button onClick={closeEditModal} style={{
                    padding: '8px', border: 'none', background: 'none', cursor: 'pointer', borderRadius: '6px'
                }}>
                    <X style={{ width: '20px', height: '20px', color: '#6b7280' }} />
                </button>
            </div>

            {/* Error */}
            {formError && (
                <div style={{
                    backgroundColor: '#fef2f2', border: '1px solid #fecaca',
                    color: '#dc2626', padding: '12px', borderRadius: '8px',
                    marginBottom: '20px', fontSize: '14px', display: 'flex', alignItems: 'center'
                }}>
                    <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                    {formError}
                </div>
            )}

            {/* FORMULAIRE COMPLET */}
            <form onSubmit={handleEditProduct}>
                <div style={{ display: 'grid', gap: '20px' }}>
                    {/* Row 1: Name and Category */}
                    <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '16px' }}>
                        <div>
                            <label style={{
                                display: 'block', fontSize: '14px', fontWeight: '500',
                                color: '#374151', marginBottom: '6px'
                            }}>
                                <Package style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                Nom du produit *
                            </label>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleInputChange}
                                required
                                style={{
                                    width: '100%', padding: '12px', border: '1px solid #d1d5db',
                                    borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box'
                                }}
                            />
                        </div>

                        <div>
                            <label style={{
                                display: 'block', fontSize: '14px', fontWeight: '500',
                                color: '#374151', marginBottom: '6px'
                            }}>
                                <Layers style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                Catégorie
                            </label>
                            <select
                                name="category"
                                value={formData.category}
                                onChange={handleInputChange}
                                style={{
                                    width: '100%', padding: '12px', border: '1px solid #d1d5db',
                                    borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box'
                                }}
                            >
                                {categoryOptions.map(cat => (
                                    <option key={cat.value} value={cat.value}>{cat.label}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Row 2: SKU and Price */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                        <div>
                            <label style={{
                                display: 'block', fontSize: '14px', fontWeight: '500',
                                color: '#374151', marginBottom: '6px'
                            }}>
                                <Hash style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                SKU *
                            </label>
                            <input
                                type="text"
                                name="sku"
                                value={formData.sku}
                                onChange={handleInputChange}
                                required
                                style={{
                                    width: '100%', padding: '12px', border: '1px solid #d1d5db',
                                    borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box'
                                }}
                            />
                        </div>

                        <div>
                            <label style={{
                                display: 'block', fontSize: '14px', fontWeight: '500',
                                color: '#374151', marginBottom: '6px'
                            }}>
                                <DollarSign style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                Prix (€) *
                            </label>
                            <input
                                type="number"
                                step="0.01"
                                name="price"
                                value={formData.price}
                                onChange={handleInputChange}
                                required
                                style={{
                                    width: '100%', padding: '12px', border: '1px solid #d1d5db',
                                    borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box'
                                }}
                            />
                        </div>
                    </div>

                    {/* Row 3: Stock, Min Stock, Unit */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
                        <div>
                            <label style={{
                                display: 'block', fontSize: '14px', fontWeight: '500',
                                color: '#374151', marginBottom: '6px'
                            }}>
                                Stock actuel
                            </label>
                            <input
                                type="number"
                                name="stock"
                                value={formData.stock}
                                onChange={handleInputChange}
                                style={{
                                    width: '100%', padding: '12px', border: '1px solid #d1d5db',
                                    borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box'
                                }}
                            />
                        </div>

                        <div>
                            <label style={{
                                display: 'block', fontSize: '14px', fontWeight: '500',
                                color: '#374151', marginBottom: '6px'
                            }}>
                                Stock minimum
                            </label>
                            <input
                                type="number"
                                name="minStock"
                                value={formData.minStock}
                                onChange={handleInputChange}
                                style={{
                                    width: '100%', padding: '12px', border: '1px solid #d1d5db',
                                    borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box'
                                }}
                            />
                        </div>

                        <div>
                            <label style={{
                                display: 'block', fontSize: '14px', fontWeight: '500',
                                color: '#374151', marginBottom: '6px'
                            }}>
                                Unité
                            </label>
                            <select
                                name="unit"
                                value={formData.unit}
                                onChange={handleInputChange}
                                style={{
                                    width: '100%', padding: '12px', border: '1px solid #d1d5db',
                                    borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box'
                                }}
                            >
                                {unitOptions.map(unit => (
                                    <option key={unit} value={unit}>{unit}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Row 4: Supplier */}
                    <div>
                        <label style={{
                            display: 'block', fontSize: '14px', fontWeight: '500',
                            color: '#374151', marginBottom: '6px'
                        }}>
                            <User style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                            Fournisseur *
                        </label>
                        <input
                            type="text"
                            name="supplier"
                            value={formData.supplier}
                            onChange={handleInputChange}
                            required
                            style={{
                                width: '100%', padding: '12px', border: '1px solid #d1d5db',
                                borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box'
                            }}
                        />
                    </div>

                    {/* Row 5: Description */}
                    <div>
                        <label style={{
                            display: 'block', fontSize: '14px', fontWeight: '500',
                            color: '#374151', marginBottom: '6px'
                        }}>
                            Description
                        </label>
                        <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleInputChange}
                            rows="3"
                            style={{
                                width: '100%', padding: '12px', border: '1px solid #d1d5db',
                                borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', resize: 'vertical'
                            }}
                        />
                    </div>
                </div>

                {/* Form Actions */}
                <div style={{
                    display: 'flex', gap: '12px', marginTop: '24px',
                    paddingTop: '20px', borderTop: '1px solid #e5e7eb'
                }}>
                    <button
                        type="button"
                        onClick={closeEditModal}
                        style={{
                            flex: 1, padding: '12px 20px', border: '1px solid #d1d5db',
                            background: 'white', color: '#374151', borderRadius: '8px',
                            fontSize: '14px', fontWeight: '500', cursor: 'pointer'
                        }}
                    >
                        Annuler
                    </button>
                    <button
                        type="submit"
                        disabled={isSubmitting}
                        style={{
                            flex: 2, padding: '12px 20px', border: 'none',
                            background: isSubmitting ? '#9ca3af' : '#f59e0b',
                            color: 'white', borderRadius: '8px', fontSize: '14px',
                            fontWeight: '500', cursor: isSubmitting ? 'not-allowed' : 'pointer',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'
                        }}
                    >
                        {isSubmitting ? (
                            <>
                                <RefreshCw style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
                                Mise à jour...
                            </>
                        ) : (
                            <>
                                <Edit style={{ width: '16px', height: '16px' }} />
                                Mettre à jour
                            </>
                        )}
                    </button>
                </div>
            </form>
        </div>
    </div>
)}
            {/* Sidebar */}
            <aside className="sidebar">
                    <div className="sidebar-header">
                        <div 
                            className="sidebar-logo-container"
                            onClick={() => navigate('/dashboard')}
                            style={{
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                borderRadius: '8px',
                                padding: '8px'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                                e.currentTarget.style.transform = 'scale(1.02)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent';
                                e.currentTarget.style.transform = 'scale(1)';
                            }}
                            title="Retour au Dashboard"
                        >
                            <div className="sidebar-logo">
                                <Building style={{ width: '24px', height: '24px', color: 'white' }} />
                            </div>
                            <div className="sidebar-brand">
                                <h1 className="sidebar-title">UNITECH IKK</h1>
                                <p className="sidebar-subtitle">Enterprise Dashboard</p>
                            </div>
                        </div>
                    </div>

<nav className="sidebar-nav">
  {filteredMenuItems.map((item) => (
    <div
      key={item.id}
      className={`nav-item ${activeMenuItem === item.id ? 'active' : ''}`}
      onClick={() => {
        setActiveMenuItem(item.id);
        navigate(item.path);
      }}
    >
      {item.isImage ? (
        <img 
          src={item.icon} 
          alt={item.label}
          className="nav-icon-image"
          style={{ 
            width: '20px', 
            height: '20px',
            display: 'block' // Ensures proper alignment
          }}
        />
      ) : (
        <item.icon 
          style={{ 
            width: '20px', 
            height: '20px',
            display: 'block' // Ensures consistency with images
          }} 
        />
      )}
      <span className="nav-text">{item.label}</span>
    </div>
  ))}
</nav>

                <div className="sidebar-footer">
                    <div className="user-profile">
                        <div className="user-avatar">{getUserInitials()}</div>
                        <div className="user-info">
                            <p className="user-name">{getDisplayName()}</p>
                            <p className="user-role">{user?.role || 'Utilisateur'}</p>
                        </div>
                        <button
                            className="logout-button"
                            onClick={handleLogout}
                            title="Se déconnecter"
                        >
                            <LogOut style={{ width: '16px', height: '16px' }} />
                        </button>
                    </div>
                </div>
            </aside>

            {/* Main Content */}
            <main className="main-content">
                {/* Header */}
                <header className="header">
                    <div className="header-content">
                        <div className="header-left">
                            <button
                                className="menu-toggle"
                                onClick={() => setSidebarOpen(!sidebarOpen)}
                            >
                                {sidebarOpen ?
                                    <X style={{ width: '20px', height: '20px' }} /> :
                                    <Menu style={{ width: '20px', height: '20px' }} />
                                }
                            </button>

                            <nav className="breadcrumb">
                                <div className="breadcrumb-item">
                                    <Home style={{ width: '16px', height: '16px' }} />
                                    <span>Dashboard</span>
                                </div>
                                <ChevronRight style={{ width: '14px', height: '14px' }} />
                                <div className="breadcrumb-item">
                                    <Package style={{ width: '16px', height: '16px' }} />
                                    <span>Inventory</span>
                                </div>
                                <ChevronRight style={{ width: '14px', height: '14px' }} />
                                <div className="breadcrumb-item">
                                    <span>Produits</span>
                                </div>
                            </nav>
                        </div>

                    <div className="header-right">
                        <div className="search-container">
                            <input
                                type="text"
                                className="search-input"
                                placeholder="Rechercher..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <Search className="search-icon" style={{ width: '18px', height: '18px' }} />
                        </div>

                        <div className="header-actions">
                            <button
                                className="header-button"
                                onClick={handleRefresh}
                                disabled={isLoading}
                                title="Actualiser"
                            >
                                <RefreshCw style={{
                                    width: '18px',
                                    height: '18px',
                                    transform: isLoading ? 'rotate(360deg)' : 'none',
                                    transition: 'transform 1s linear'
                                }} />
                            </button>

                            <button 
                                className="header-button"
                                title="Notifications"
                            >
                                <Bell style={{ width: '18px', height: '18px' }} />
                                {notifications.length > 0 && (
                                    <span className="notification-badge">{notifications.length}</span>
                                )}
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/settings')}
                                title="Paramètres système"
                            >
                                <Settings style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/project_management')}
                                title="Gestion de projets"
                            >
                                <Folder style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/technical_support')}
                                title="Technical Support"
                            >
                                <MonitorCog style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/admin_support_it')}
                                title="Admin Support IT"
                            >
                                <SquareActivity style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/mytickets')}
                                title="My Tickets"
                            >
                                <Tickets style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/quotations')}
                                title="Quotation System"
                            >
                                <Receipt style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/clients')}
                                title="Clients"
                            >
                                <Briefcase style={{ width: '18px', height: '18px' }} />
                            </button>

                            <div className="time-display">
                                {currentTime.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                            </div>
                        </div>
                    </div>
                    </div>
                </header>

                {/* Products Content */}
                <div className="products-content">
                    {/* Error Display */}
                    {error && (
                        <div className="error-message" style={{
                            background: '#fef2f2',
                            border: '1px solid #fecaca',
                            color: '#dc2626',
                            padding: '12px',
                            borderRadius: '8px',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                            {error}
                        </div>
                    )}

                    {/* Page Header */}
                    <div className="page-header">
                        <h1 className="page-title">Products Management</h1>
                        <p className="page-subtitle">
                            Gérez votre inventaire de matériaux et équipements de construction.
                        </p>

                        <div className="page-actions">
                            <button 
                                className="action-button"
                                onClick={openAddModal}
                                style={{ cursor: 'pointer' }}
                            >
                                <Plus style={{ width: '16px', height: '16px' }} />
                                Ajouter Produit
                            </button>
                            <button className="action-button secondary">
                                <Download style={{ width: '16px', height: '16px' }} />
                                Exporter
                            </button>
                            <button className="action-button secondary">
                                <ShoppingCart style={{ width: '16px', height: '16px' }} />
                                Commander
                            </button>
                        </div>
                    </div>

                    {/* Categories Section */}
                    <div className="categories-section">
                        <h2 className="section-title">Catégories de Produits</h2>
                        <div className="categories-grid">
                            {categories.map((category) => {
                                const IconComponent = getCategoryIcon(category.id);
                                return (
                                    <div
                                        key={category.id}
                                        className={`category-card ${selectedCategory === category.id ? 'active' : ''}`}
                                        onClick={() => setSelectedCategory(category.id)}
                                    >
                                        <div className="category-header">
                                            <div className="category-icon">
                                                <IconComponent style={{ width: '20px', height: '20px', color: 'white' }} />
                                            </div>
                                            <h3 className="category-name">{category.name}</h3>
                                        </div>
                                        <p className="category-count">{category.count} produits</p>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {/* Filters Section */}
                    <div className="filters-section">
                        <div className="filters-row">
                            <div className="filter-group">
                                <label className="filter-label">Recherche</label>
                                <input
                                    type="text"
                                    className="filter-input"
                                    placeholder="Nom, SKU, fournisseur..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Trier par</label>
                                <select
                                    className="filter-select"
                                    value={sortBy}
                                    onChange={(e) => setSortBy(e.target.value)}
                                >
                                    <option value="name">Nom</option>
                                    <option value="price">Prix</option>
                                    <option value="stock">Stock</option>
                                    <option value="updatedAt">Dernière MAJ</option>
                                </select>
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Ordre</label>
                                <select
                                    className="filter-select"
                                    value={sortOrder}
                                    onChange={(e) => setSortOrder(e.target.value)}
                                >
                                    <option value="asc">Croissant</option>
                                    <option value="desc">Décroissant</option>
                                </select>
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Actions</label>
                                <button className="action-button secondary">
                                    <Filter style={{ width: '16px', height: '16px' }} />
                                    Filtres avancés
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Products Table */}
                    <div className="products-table-section">
                        <div className="table-header">
                            <h2 className="table-title">
                                {selectedCategory === 'all' ? 'Tous les produits' : 
                                 categories.find(c => c.id === selectedCategory)?.name || 'Produits'}
                            </h2>
                            <span className="table-stats">
                                {pagination.total} produit{pagination.total > 1 ? 's' : ''} trouvé{pagination.total > 1 ? 's' : ''}
                                {isLoading && ' (chargement...)'}
                            </span>
                        </div>

                        <table className="products-table">
                            <thead className="table-head">
                                <tr>
                                    <th onClick={() => {
                                        setSortBy('name');
                                        setSortOrder(sortBy === 'name' && sortOrder === 'asc' ? 'desc' : 'asc');
                                    }} style={{ cursor: 'pointer' }}>
                                        Produit {sortBy === 'name' && (sortOrder === 'asc' ? '↑' : '↓')}
                                    </th>
                                    <th onClick={() => {
                                        setSortBy('price');
                                        setSortOrder(sortBy === 'price' && sortOrder === 'asc' ? 'desc' : 'asc');
                                    }} style={{ cursor: 'pointer' }}>
                                        Prix {sortBy === 'price' && (sortOrder === 'asc' ? '↑' : '↓')}
                                    </th>
                                    <th onClick={() => {
                                        setSortBy('stock');
                                        setSortOrder(sortBy === 'stock' && sortOrder === 'asc' ? 'desc' : 'asc');
                                    }} style={{ cursor: 'pointer' }}>
                                        Stock {sortBy === 'stock' && (sortOrder === 'asc' ? '↑' : '↓')}
                                    </th>
                                    <th>Statut</th>
                                    <th>Fournisseur</th>
                                    <th onClick={() => {
                                        setSortBy('updatedAt');
                                        setSortOrder(sortBy === 'updatedAt' && sortOrder === 'asc' ? 'desc' : 'asc');
                                    }} style={{ cursor: 'pointer' }}>
                                        Dernière MAJ {sortBy === 'updatedAt' && (sortOrder === 'asc' ? '↑' : '↓')}
                                    </th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody className="table-body">
                                {products.map((product) => {
                                    const status = getStatusBadge(product.status, product.stock, product.minStock);
                                    return (
                                        <tr key={product._id}>
                                            <td>
                                                <div>
                                                    <div className="product-name">{product.name}</div>
                                                    <div className="product-sku">SKU: {product.sku}</div>
                                                </div>
                                            </td>
                                            <td>
                                                <span className="product-price">
                                                    €{product.price.toFixed(2)}
                                                </span>
                                            </td>
                                            <td>
                                                <div className="stock-info">
                                                    <span className="stock-value">{product.stock}</span>
                                                    <span className="stock-unit">{product.unit}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <span className={`status-badge ${status.class}`}>
                                                    {status.text}
                                                </span>
                                            </td>
                                            <td>{product.supplier}</td>
                                            <td>
                                                {new Date(product.updatedAt).toLocaleDateString('fr-FR')}
                                            </td>
                                            <td>
                                                <div className="actions-cell">
                                                    <button 
                                                        className="action-icon" 
                                                        title="Voir détails"
                                                        onClick={() => openViewModal(product)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <Eye style={{ width: '16px', height: '16px' }} />
                                                    </button>
                                                    {(user.role === 'manager' || user.role === 'admin') && (
                                                        <button 
                                                            className="action-icon edit" 
                                                            title="Modifier"
                                                            onClick={() => openEditModal(product)}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            <Edit style={{ width: '16px', height: '16px' }} />
                                                        </button>
                                                    )}
                                                    {user.role === 'admin' && (
                                                        <button 
                                                            className="action-icon delete" 
                                                            title="Supprimer"
                                                            onClick={() => handleDeleteProduct(product._id)}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            <Trash2 style={{ width: '16px', height: '16px' }} />
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>

                        {products.length === 0 && !isLoading && (
                            <div style={{ 
                                padding: '40px', 
                                textAlign: 'center', 
                                color: '#64748b',
                                borderTop: '1px solid rgba(30, 64, 175, 0.05)'
                            }}>
                                <Package style={{ width: '48px', height: '48px', margin: '0 auto 16px', opacity: 0.5 }} />
                                <p style={{ fontSize: '16px', fontWeight: '500', marginBottom: '8px' }}>
                                    Aucun produit trouvé
                                </p>
                                <p style={{ fontSize: '14px' }}>
                                    Essayez de modifier vos critères de recherche ou filtres.
                                </p>
                            </div>
                        )}

                        {isLoading && (
                            <div style={{ 
                                padding: '40px', 
                                textAlign: 'center', 
                                color: '#64748b'
                            }}>
                                <RefreshCw style={{ 
                                    width: '24px', 
                                    height: '24px', 
                                    margin: '0 auto 16px', 
                                    animation: 'spin 1s linear infinite' 
                                }} />
                                <p>Chargement des produits...</p>
                            </div>
                        )}

                        {/* Pagination */}
                        {pagination.pages > 1 && (
                            <div style={{ 
                                padding: '20px', 
                                display: 'flex', 
                                justifyContent: 'center', 
                                alignItems: 'center',
                                gap: '10px'
                            }}>
                                <button 
                                    onClick={() => setPagination(prev => ({ ...prev, page: Math.max(1, prev.page - 1) }))}
                                    disabled={pagination.page === 1}
                                    style={{
                                        padding: '8px 12px',
                                        border: '1px solid #d1d5db',
                                        borderRadius: '6px',
                                        background: 'white',
                                        cursor: pagination.page === 1 ? 'not-allowed' : 'pointer'
                                    }}
                                >
                                    Précédent
                                </button>
                                <span style={{ margin: '0 15px' }}>
                                    Page {pagination.page} sur {pagination.pages}
                                </span>
                                <button 
                                    onClick={() => setPagination(prev => ({ ...prev, page: Math.min(prev.pages, prev.page + 1) }))}
                                    disabled={pagination.page === pagination.pages}
                                    style={{
                                        padding: '8px 12px',
                                        border: '1px solid #d1d5db',
                                        borderRadius: '6px',
                                        background: 'white',
                                        cursor: pagination.page === pagination.pages ? 'not-allowed' : 'pointer'
                                    }}
                                >
                                    Suivant
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </main>
        </div>
    );
};

export default UnitechProductsPage;